/**
 *
 * @param {Object} win
 * @param {String} pref
 * @returns
 */
const getKeysForExtraInfo = (win, pref) => {
	const params = new Map();

	if (pref) {
		pref.split(',').forEach((param) => {
			if (param.indexOf('=') > -1) {
				const [paramName, extraInfoName] = param.split('=');
				params.set(paramName, extraInfoName);
			} else {
				params.set(param, param);
			}
		});
	}

	return params;
};

export default getKeysForExtraInfo;
